import styled from '@emotion/styled';

import { LIGHT_BLUE_RGBA, PP_SECONDARY_COLOR } from '@/styles';

export const AccordionContent = styled.div`
  width: 100%;
  height: auto;
`;

export const AccordionButtonContainer = styled.div<{
  alignButtonContent?: string;
}>`
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
  justify-content: ${({ alignButtonContent }) =>
    alignButtonContent ? alignButtonContent : 'start'};
  align-items: center;
`;

export const AccordionContainer = styled.div<{ isActive: boolean }>`
  width: 100%;
  height: ${({ isActive }) => (isActive ? 'auto' : '48px')};
`;

export const AccordionButton = styled.button<{ fontSize?: string }>`
  align-items: center;
  background-color: transparent;
  border: unset;
  color: ${PP_SECONDARY_COLOR};
  display: flex;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '18px')};
  font-weight: 700;
  padding: 12px 8px;

  &:hover {
    text-decoration: underline;
  }

  &:focus {
    border-radius: 4px;
    border: 3px solid ${PP_SECONDARY_COLOR};
    box-shadow: ${LIGHT_BLUE_RGBA} 0 0 0 6px;
    text-decoration: underline;
    transition: all 0.2s ease-in;
  }
`;

export const ChevronContainer = styled.span`
  align-items: center;
  display: inline-flex;
  height: 24px;
  justify-content: center;
  margin-left: 5px;
  width: 24px;
`;
